import React from "react";

import { UseCases } from "@planzone/core";
import {
  useTaskStatusCreation,
  useTaskStatusesRetrieval,
} from "@planzone/view-models";
import { Props } from "./types";
import { Status } from "./status";
import { Safeguard } from "@scenes/safeguard";

function TaskStatus(props: Props) {
  const { isRequestPending: isStatusCreationRequestPending, createTaskStatus } =
    useTaskStatusCreation();
  const [canCreateStatus, setCanCreateStatus] = React.useState(false);
  const {
    statuses,
    retrieveTaskStatuses,
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
  } = useTaskStatusesRetrieval(props.project);
  const doneStatus = statuses.find(
    ({ percentComplete, label }) =>
      label === "pr_done" || percentComplete === 100,
  );
  const selectedStatus = props.isCompleted
    ? doneStatus || props.status
    : props.status;

  React.useEffect(() => {
    !!props.project.uuid &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveTaskStatuses(props.project);
  }, [props.project.uuid]);

  return (
    <Safeguard
      useCases={[UseCases.editTask]}
      context={{ project: props.project }}
    >
      {({ canEditTask }) => (
        <Status
          status={selectedStatus}
          statuses={statuses}
          canCreateStatus={canCreateStatus}
          isReduced={props.isReduced}
          canEditStatus={canEditTask && !props.project.isTemplate}
          isRequestPending={isStatusCreationRequestPending}
          canAddStatus={props.canAddStatus}
          prepareStatusCreation={() => setCanCreateStatus(true)}
          createStatus={(status) =>
            createTaskStatus({ project: props.project, status })
          }
          selectStatus={(status) => {
            props.selectStatus && props.selectStatus(status);
          }}
        />
      )}
    </Safeguard>
  );
}

export { TaskStatus };
